// extracted by css-extract-rspack-plugin
export default {"winsorizationAndWindowing":"L1Vfm96iUoUVRvcM","settingLinks":"mkkvvVAvvIQSSsG9","settingsCard":"Ex9rHloLyvk8WWFv"};